<template>
  <div class="welcomeInfoCard">
    <div class="welcomeInfoCard__pic">
      <img alt="" class="welcomeInfoCard__image" :src="imageUrl" />
    </div>
    <div class="welcomeInfoCard__message">
      <h2
        v-if="greeting?.[$i18n.locale] !== ''"
        class="welcomeInfoCard__title global-medium-title"
      >
        {{ greeting?.[$i18n.locale] }}
      </h2>
      <p
        class="welcomeInfoCard__text global-main-1"
        v-html="text?.[$i18n.locale]"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "welcomeInfoCard",
  props: {
    greeting: [Object, undefined],
    imageUrl: [String, undefined],
    text: [Object, undefined],
  },
};
</script>

<style lang="scss">
.welcomeInfoCard__pic {
  width: 100%;
  margin-bottom: 15px;
  overflow: hidden;
  border-radius: 12px;
}

.welcomeInfoCard__image {
  width: 100%;
  display: block;
}

.welcomeInfoCard__message {
  background: var(--color-tile);
  border-radius: 10px;
  padding: 20px;
}

.welcomeInfoCard__title {
  margin-bottom: 10px;
  color: var(--color-text);
}

.welcomeInfoCard__text {
  margin-bottom: 0;
  color: var(--color-text);
}

@include media-breakpoint-up(sm) {
  .welcomeInfoCard {
    background: var(--color-tile);
    padding: 30px;
    border-radius: 10px;
  }
  .welcomeInfoCard__pic {
    margin-bottom: 30px;
  }
  .welcomeInfoCard__text {
    margin-bottom: 0;
  }
  .welcomeInfoCard__message {
    padding: 0;
  }
}
</style>
